import { ngCellEx } from "./_ngCell.js";

class ngRenderer extends ngCellEx
{
	#target;
	
	constructor() {
		super();

		this.applyBaseStyle();
	}
	
	connectedCallback() {

		const link					= this.getAttribute("link") == "true";
		const align					= this.closest("th,td").getAttribute("text-align") || "left";
		const justifyContent		= align == "left" ? "flex-start" : (align == "right" ? "flex-end" : "center");
		
		this.cell = this.closest("th,td");
		if (!this.cell) {
			//$(this).hide();
			return;
		}
		
		//const textAlign = this.getAttribute("text-align") || this.cell.getAttribute("text-align") || "left";
		const color = this.getAttribute("color") || this.cell.getAttribute("color") || "";
		//const iconSize = this.getAttribute("icon-size") || this.cell.getAttribute("icon-size") || 12;

		this.shadowRoot.innerHTML =`
			<style>
				span {
					color: ${color};
				}
				div.ng-wrap {
					justify-content: ${justifyContent};
				}
			</style>
			
			<div class="ng-wrap">
				<span class="renderer"></span>
			</div>
		`;
		
		super.connectedCallback();
		
		this.#target = this.shadowRoot.querySelector("span.renderer");
		
		/**
		this.#target.addEventListener("click", (e) => {
			console.log("11111", this.cell);
			const event = new CustomEvent("onlinkclick", { detail: { data: this.cell.closest("tr").data, currow: parseInt(this.cell.dataset.row) }, bubbles: true, composed: true });
			//this.#target.dispatchEvent(new CustomEvent("onlinkclick", { detail: { data: this.cell.closest("tr").data, currow: parseInt(this.cell.dataset.row) }, bubbles: true, composed: true }));
			this.#target.dispatchEvent(event);
			//this.owner.dispatchEvent(new CustomEvent("onlinkclick", { detail: { data: this.cell.closest("tr").data, currow: parseInt(this.cell.dataset.row) }, bubbles: true, composed: true }));
			//const vueComponent = this.getRootNode().host;
			//console.log(vueComponent, vueComponent.__vue__);
			
			//if (vueComponent && vueComponent.__vue__) { vueComponent.__vue__.$emit("onlinkclick", event.detail); }
			//window.dispatchEvent(event);
		}); */
	};
	
	dataRefresh = (v) => {
		if (!this.#target) return;
		
		this.#target.innerHTML = this.getDisplayText();
		if (!v) this.reset();
	};
}

if (!customElements.get('ng-renderer')) {
	customElements.define("ng-renderer", ngRenderer);
}
